import { env } from '../env.js';
import { SELECTED_ACCOUNTS_COOKIE } from './consts.js';

interface CookieOptions {
  path?: string;
  sameSite?: 'Strict' | 'Lax' | 'None';
}

export function setCookie(
  name: string,
  value: string,
  { path = '/', sameSite = 'Strict' }: CookieOptions = {},
): void {
  // biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API is async and unsupported in Safari/Firefox; this helper must stay synchronous.
  document.cookie = `${name}=${value}; path=${path}; SameSite=${sameSite}`;
}

export function getCookie(name: string): string | null {
  const entry = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`));
  return entry ? entry.slice(name.length + 1) : null;
}

export function setSelectionCookie(accountIds: number[]): void {
  setCookie(SELECTED_ACCOUNTS_COOKIE, accountIds.join(','));
}

export function clearSelectionCookie(): void {
  // biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API is async and unsupported in Safari/Firefox; this helper must stay synchronous.
  document.cookie = `${SELECTED_ACCOUNTS_COOKIE}=; path=/; max-age=0; SameSite=Strict`;
}

export function hasSelectionCookie(): boolean {
  return Boolean(getCookie(SELECTED_ACCOUNTS_COOKIE));
}

export function getSelectionCookie(): number[] {
  const value = getCookie(SELECTED_ACCOUNTS_COOKIE);
  return value ? value.split(',').map(Number).filter(Number.isFinite) : [];
}

export async function mintJwtCookie(): Promise<boolean> {
  const res = await fetch(`${env.apiUrl}/api/auth/jwt-cookie`, {
    method: 'POST',
    credentials: 'include',
  });
  return res.ok;
}
